import React, { memo } from "react";
import { FlatList, StyleSheet, View, Text, Image } from "react-native";
import { FONT_FAMILY, images, THEME_COLORS } from "../themes";

interface MjrTimelineComponentProps {
  data: any[];
}

interface ILineWithText {
  isLast: boolean;
  statusColor: string;
  label: string;
  time: string;
  text: string;
  color: string;
}

const LineWithText = (props: ILineWithText) => {
  const { isLast, time, text, color, statusColor } = props;

  return (
    <View style={{ height: "100%", justifyContent: "center", flex: 1 }}>
      <View style={styles.container}>
        <Image
          source={images.pointIcon}
          style={[styles.point, { tintColor: statusColor }]}
        />
        {isLast ? (
          <></>
        ) : (
          <View style={[styles.line, { backgroundColor: color }]} />
        )}
      </View>
      <Text
        style={{
          color: THEME_COLORS.primary,
          marginVertical: 2,
          fontFamily: FONT_FAMILY.three,
          fontSize: 13,
        }}
      >
        {text}
      </Text>
      <View style={{ flexDirection: "row" }}>
        {time && (
          <Text style={{ fontFamily: FONT_FAMILY.two, fontSize: 13 }}>
            {time}
          </Text>
        )}
      </View>
    </View>
  );
};

const MjrTimelineComponent = ({ data }: MjrTimelineComponentProps) => {
  return (
    <FlatList
      data={data}
      horizontal={true}
      keyExtractor={(_, index) => index.toString()}
      renderItem={({ item, index }) => {
        const { color, date, label } = item;

        let isLast = index === data.length - 1;

        return (
          <LineWithText
            key={index.toString()}
            isLast={isLast}
            statusColor={"#1CCA77"}
            time={date}
            text={label}
            color={"#1CCA77"}
            label=""
          />
        );
      }}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  point: {
    width: 18,
    height: 18,
  },
  line: {
    width: 280.79,
    height: 2,
  },
});

export default memo(MjrTimelineComponent);
